export const ASSET_PRICE_UPDATED_EVENT = "asset-price-updated";
export const SPOT_ORDERS_CHANGED_EVENT = "spot-orders-changed";

export function notifyAssetPriceUpdated(detail = {}) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(ASSET_PRICE_UPDATED_EVENT, { detail })
  );
}

export function notifySpotOrdersChanged(detail = {}) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(SPOT_ORDERS_CHANGED_EVENT, { detail })
  );
}
